export default class StudentPermissions {
  constructor(role = 'Manager') {
    this.role = role;
  }

  canViewAudit() {
    return ['Admin', 'Manager', 'Auditor'].includes(this.role);
  }

  canEditStudent() {
    return ['Admin', 'Manager'].includes(this.role);
  }

  canViewEvent(event) {
    if (!event?.visibility) return true;
    return event.visibility.includes(this.role);
  }

  canEditSensitive() {
    return ['Admin', 'Manager'].includes(this.role);
  }
}
